import { render, staticRenderFns } from "./QTextField.vue?vue&type=template&id=88808e9e&scoped=true&"
import script from "./QTextField.vue?vue&type=script&lang=js&"
export * from "./QTextField.vue?vue&type=script&lang=js&"
import style0 from "./QTextField.vue?vue&type=style&index=0&id=88808e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88808e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
